/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_PARTIES_SUCCESS,
  LOAD_PARTIES_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_PARTIES_RECORDS_META_DATA_SUCCESS,
  LOAD_PARTIES_RECORDS_META_DATA_ERROR,
  CREATE_PARTIES_SUCCESS,
  UPDATE_PARTIES_SUCCESS,
  DELETE_PARTIES_SUCCESS,
  LOAD_PARTIES_CATEGORY_SUCCESS,
  LOAD_PARTIES_CATEGORY_ERROR,
  CREATE_PARTIES_CATEGORY_SUCCESS,
  CREATE_PARTIES_CATEGORY_ERROR,
  CREATE_PARTIES_ERROR,
  UPDATE_PARTIES_ERROR,
  DELETE_PARTIES_ERROR,
  LOAD_PARTIES_COLLECT_SUCCESS,
  LOAD_PARTIES_COLLECT_ERROR,
  LOAD_PARTIES_PAY_SUCCESS,
  LOAD_PARTIES_PAY_ERROR,
  LOAD_STATE_LIST_SUCCESS,
  LOAD_STATE_LIST_ERROR,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PARTIES_TRANSACTION_ERROR,
  LOAD_PARTIES_LEDGER_STATEMENT_SUCCESS,
  LOAD_PARTIES_LEDGER_STATEMENT_ERROR,
} from "./constants";

const initialState = {
  parties_list: [],
  state_list: [],
  parties_collect_list: [],
  parties_pay_list: [],
  category_list: [],
  parties_transaction_list: [],
  ledger_statement_list: [],
  record: {},
  records: {},
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    parties_list,
    state_list,
    category_list,
    parties_collect_list,
    parties_transaction_list,
    ledger_statement_list,
    parties_pay_list,
    record,
    recordsMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PARTIES_SUCCESS:
        draft.parties_list = parties_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_STATE_LIST_SUCCESS:
        draft.state_list = state_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PARTIES_COLLECT_SUCCESS:
        draft.parties_collect_list = parties_collect_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PARTIES_CATEGORY_SUCCESS:
        draft.category_list = category_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_PARTIES_CATEGORY_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case LOAD_PARTIES_PAY_SUCCESS:
        draft.parties_pay_list = parties_pay_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PARTIES_LEDGER_STATEMENT_SUCCESS:
        draft.ledger_statement_list = ledger_statement_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PARTIES_TRANSACTION_SUCCESS:
        draft.parties_transaction_list = parties_transaction_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_PARTIES_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_PARTIES_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_PARTIES_SUCCESS:
        draft.record = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_PARTIES_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_PARTIES_ERROR:
      case LOAD_STATE_LIST_ERROR:
      case LOAD_PARTIES_COLLECT_ERROR:
      case LOAD_PARTIES_PAY_ERROR:
      case LOAD_PARTIES_CATEGORY_ERROR:
      case CREATE_PARTIES_CATEGORY_ERROR:
      case LOAD_PARTIES_TRANSACTION_ERROR:
      case LOAD_PARTIES_LEDGER_STATEMENT_ERROR:
      case CREATE_PARTIES_ERROR:
      case UPDATE_PARTIES_ERROR:
      case DELETE_PARTIES_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_PARTIES_RECORDS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
